module.exports = __webpack_public_path__ + "media/images/consumer/contest_notification_mailer/contest_5_readings-58b75e0fd40c8c6f1c92984a6fce30c2.png";